import * as Sentry from '@sentry/react';
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension';
import { rootReducer } from './reducers';
import rootSaga from './sagas';

const sagaMiddleware = createSagaMiddleware({
  // An uncaught saga error stops the root saga and never reaches window.onerror.
  onError: (error, { sagaStack }) => {
    Sentry.captureException(error, { extra: { sagaStack } });
    console.error(error, sagaStack);
  },
});
const store = createStore(
  rootReducer,
  composeWithDevTools(
    applyMiddleware(sagaMiddleware),
    // Breadcrumbs carry only the action type: no payload or state leaves the browser.
    Sentry.createReduxEnhancer({
      attachReduxState: false,
      actionTransformer: (action) => ({ type: action.type }),
      stateTransformer: () => null,
    }),
  ),
);
sagaMiddleware.run(rootSaga);

export default store;
